// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"515":"7a879b03","610":"ed169e79","720":"30acbe1e","923":"ed169e79"}[chunkId] + ".css";
};